<div class="grid-2col_minMax gap">
    <!-- Basic Info -->
    <app-person-edit-basic-info
        class="fh-2"
        [form]="form"
        [canEdit]="store.canEditPersonInfo() || personId === null"
        [person]="person"
        [serviceType]="serviceType()"
        (uploaded)="form.patchValue({ image: $event })"
    ></app-person-edit-basic-info>

    <!-- Additional Info section -->
    <app-person-additional-info
        [form]="form"
        [canEdit]="store.canEditPersonInfo() || personId === null"
        [errorMsg]="errorMsg()"
    ></app-person-additional-info>
    <!-- Contact info section -->
    <app-person-contact-info
        [form]="form"
        [canEdit]="store.canEditPersonInfo() || personId === null"
        [personId]="personId"
    ></app-person-contact-info>
</div>

<div class="grid-2col_minMax gap mt-3">
    <div class="flex-column gap">
        <!-- Pobyt ve složce - jen při přidávání další osoby do složky -->
        @if (folderPersonCreate) {
            <app-card [title]="'folder.persons.label'" titleSize="large">
                <ng-template #content>
                    <div class="input-grid-gaps grid-12col p-1">
                        <app-date-input
                            class="fr-4"
                            id="dateFrom"
                            label="folder.persons.fields.inFolderFrom"
                            [form]="folderPersonForm"
                        ></app-date-input>
                    </div>

                    @if (foundPerson()) {
                        <div class="flex gap align-items-center p-1">
                            <span>{{ 'folder.persons.messages.personExists' | translate: { person: (foundPerson() | formatPerson) } }}</span>
                            <app-button
                                [label]="'folder.persons.actions.addFoundToFolder' | translate"
                                [text]="true"
                                (clickEvent)="addFoundPersonToFolder()"
                            ></app-button>
                        </div>
                    }
                </ng-template>
            </app-card>
        }
        <!-- Addresses Section -->
        <app-person-addresses
            [canEdit]="store.canEditPersonInfo() || personId === null"
            [personId]="personId"
            (newAddress)="addresses.push($event)"
        >
        </app-person-addresses>
        <!-- Insurances Section -->
        <app-person-insurance
            [canEdit]="store.canEditPersonInfo() || personId === null"
            [personId]="personId"
            (created)="insurances.push($event)"
        >
        </app-person-insurance>
        <!-- NgIf is just a hotfix due to create (no person)... no time to fix it now -->
        @if (folderId && !folderPersonCreate && (store.hasMultipleWorkplaces$ | async)) {
            <app-create-person-page-workplace-table
                [canEdit]="store.canEditPersonInfo()"
                [folderId]="folderId"
            ></app-create-person-page-workplace-table>
        }
        <!-- Payment details section - patří složce, u další osoby ve složce nedává smysl -->
        @if (!folderPersonCreate && editsFolderOwner()) {
            <app-person-payment-details
                [form]="paymentForm"
                [canEdit]="store.canEditPersonInfo() || personId === null"
            ></app-person-payment-details>
        }
    </div>

    <div class="flex-column gap">
        <!-- Notes to this folder -->
        @if (store.isAllowed('folderNote.read')() || store.isAllowed('folderNote.create')()) {
            <app-person-notes
                [canEdit]="store.isAllowed('folderNote.create')()"
                [folderId]="folderId"
                (created)="note = $event"
            >
            </app-person-notes>
        }
        <!-- Person restrictions -->
        @if (personId) {
            <app-person-restrictions
                [canEdit]="store.canEditPersonInfo() || personId === null"
                [personId]="personId"
                (created)="restrictions.push($event)"
            >
            </app-person-restrictions>
            <!-- Person authorizations -->
            <app-person-authorizations
                [canEdit]="store.canEditPersonInfo() || personId === null"
                [personId]="personId"
                (created)="authorizations.push($event)"
            >
            </app-person-authorizations>
        }
        <!-- Same Person Folders in current organization Section -->
        <!-- NgIf is just a hotfix due to create (no person)... no time to fix it now -->
        @if (person) {
            <app-person-folders-in-organization [person]="person"></app-person-folders-in-organization>
        }
    </div>
</div>

<div class="mt-3">
    <app-action-buttons
        [primaryButtonVisibility]="store.canEditPersonInfo() || (folderPersonCreate && store.isAllowed('folder.update')())"
        (primaryClickEvent)="save()"
        (secondaryClickEvent)="cancel()"
    ></app-action-buttons>
</div>
